import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { MobileNav } from "@/components/layout/MobileNav";

export const Route = createFileRoute("/_public")({
	component: PublicLayout,
});

function PublicLayout() {
	return (
		<div className="min-h-screen bg-background flex flex-col">
			<Header />
			<main className="flex-1 w-full max-w-7xl mx-auto px-4 py-6 pb-24 lg:pb-6">
				<Outlet />
			</main>
			<Footer />
			<MobileNav />
		</div>
	);
}
